// extracted by mini-css-extract-plugin
module.exports = {"container":"Stack__container__2eyKm","horizontal":"Stack__horizontal__3tH8m","vertical":"Stack__vertical__1oNwf"};